import DataFieldDisplay from "./DataFieldDisplay";

export default DataFieldDisplay;
